<div class="modal-header">
  <h3 class="modal-title" i18n="@@fastTrackPhotoTitle" id="modal-header">Fast Track photos</h3>
  <button
    type="button"
    class="close"
    aria-label="Fast Track photos close"
    ngbAutoFocus
    (click)="activeModal.close()"
  >
    <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
  </button>
</div>
<div class="modal-body">
  @if (photos?.length) {
    <div
      id="fasttrack-gallery-images"
      class="fasttrack-gallery"
      [ngClass]="{ visuallyhidden: imagesLoaded < photos.length }"
    >
      @for (image of photos; track image; let index = $index) {
        <div
          [ngClass]="{ 'highlighted-fasttrack': image === selected }"
          (click)="selected = image"
          (keydown.enter)="selected = image"
          tabindex="0"
          role="button"
          [attr.aria-pressed]="image === selected"
        >
          <img [src]="image" alt="Photo {{ index }}" (load)="imagesLoadedCount()" />
        </div>
      }
    </div>
    @if (selected) {
      <div
        id="fasttrack-gallery-selected"
        class="selected-image"
        [ngClass]="{ visuallyhidden: imagesLoaded < photos.length }"
      >
        <img [src]="selected" alt="Selected fasttrack image" />
      </div>
    }
  }
  @if (!photos?.length) {
    <div i18n="@@noPhotos">No photos...</div>
  }
</div>
